// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.custom-label-height[data-v-d7bc5ab4]{\n    height: 27px;\n}\nhr.rounded[data-v-d7bc5ab4] {\n  border-top: 8px solid #bbb;\n  border-radius: 5px;\n  width: 100%;\n}\n.warning[data-v-d7bc5ab4]{\n  color: purple;\n}\n\n    \n\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
